import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { EdpOverlayComponent } from "./edp-overlay.component";
import { EdpOverlayUserModule } from "./edp-overlay-user/edp-overlay-user.module";
import { EdpOverlayBenefitsModule } from "./edp-overlay-benefits/edp-overlay-benefits.module";
import { EdpOverlayMoreInfoModule } from "./edp-overlay-more-info/edp-overlay-more-info.module";
import { EdpOverlayNotificationsModule } from "./edp-overlay-notifications/edp-overlay-notifications.module";
import { EdpOverlayMgmModule } from "./edp-overlay-mgm/edp-overlay-mgm.module";
import { EdpOverlayUserLanguageComponent } from "./edp-overlay-user-language/edp-overlay-user-language.component";
import { EdpSelectListModule } from "@edp-components/edp-select-list/edp-select-list.module";
import { EdpLanguagesModule } from "@edp-components/edp-languages/edp-languages.module";
import { EdpOverlayPushConfigsModule } from "./edp-overlay-push-configs/edp-overlay-push-configs.module";
import { ConditionalRegionModule } from "@edp-directives/conditional-region/conditional-region.module";

@NgModule({
    declarations: [EdpOverlayComponent, EdpOverlayUserLanguageComponent],
    imports: [
        CommonModule,
        TranslateModule,
        EdpOverlayUserModule,
        EdpOverlayBenefitsModule,
        EdpOverlayMoreInfoModule,
        EdpOverlayNotificationsModule,
        EdpOverlayMgmModule,
        EdpOverlayPushConfigsModule,
        EdpSelectListModule,
        EdpLanguagesModule,
        ConditionalRegionModule
    ],
    exports: [EdpOverlayComponent],
})
export class EdpOverlayModule {}
